import React, { useState } from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { MailIcon } from 'lucide-react';
export const EmailSupport = () => {
  const [scrolled, setScrolled] = useState(false);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-6485">
      <Navbar scrolled={scrolled} data-id="element-6486" />
      <main className="pt-24 pb-20" data-id="element-6487">
        <div className="container mx-auto px-4 md:px-6" data-id="element-6488">
          <div className="max-w-3xl mx-auto bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm" data-id="element-6489">
            <div className="flex flex-col items-center text-center mb-8" data-id="element-6490">
              <div className="w-16 h-16 bg-[#2DB489]/10 rounded-full flex items-center justify-center mb-4" data-id="element-6491">
                <MailIcon className="h-8 w-8 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-6492" />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-6493">
                Contact Us via Email
              </h1>
              <p className="text-xl text-gray-600 dark:text-[#B0C1BD]" data-id="element-6494">
                Please send your inquiries to{' '}
                <a href="mailto:support@yourdomain.com" className="text-[#2DB489] dark:text-[#4ED1A0] hover:underline" data-id="element-6495">
                  support@yourdomain.com
                </a>
              </p>
              <p className="mt-4 text-gray-600 dark:text-[#B0C1BD]" data-id="element-6496">
                We typically respond within 24 hours.
              </p>
            </div>
            <div className="bg-gray-50 dark:bg-[#1A3330] rounded-lg p-6 mb-6" data-id="element-6497">
              <h2 className="text-xl font-semibold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-6498">
                What to Include in Your Email
              </h2>
              <ul className="space-y-2 text-gray-600 dark:text-[#B0C1BD]" data-id="element-6499">
                <li className="flex items-start" data-id="element-6500">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-6501">
                    •
                  </span>
                  <span data-id="element-6502">Your account email address</span>
                </li>
                <li className="flex items-start" data-id="element-6503">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-6504">
                    •
                  </span>
                  <span data-id="element-6505">Order number (if applicable)</span>
                </li>
                <li className="flex items-start" data-id="element-6506">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-6507">
                    •
                  </span>
                  <span data-id="element-6508">Detailed description of your issue or question</span>
                </li>
                <li className="flex items-start" data-id="element-6509">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-6510">
                    •
                  </span>
                  <span data-id="element-6511">Screenshots (if relevant)</span>
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-lg p-6 text-white" data-id="element-6512">
              <h2 className="text-xl font-semibold mb-2" data-id="element-6513">Support Hours</h2>
              <p className="mb-4 opacity-90" data-id="element-6514">
                Our email support team is available during the following hours:
              </p>
              <div className="space-y-1 mb-4" data-id="element-6515">
                <div className="flex justify-between" data-id="element-6516">
                  <span data-id="element-6517">Monday - Friday:</span>
                  <span data-id="element-6518">9:00 AM - 6:00 PM ET</span>
                </div>
                <div className="flex justify-between" data-id="element-6519">
                  <span data-id="element-6520">Saturday:</span>
                  <span data-id="element-6521">10:00 AM - 4:00 PM ET</span>
                </div>
                <div className="flex justify-between" data-id="element-6522">
                  <span data-id="element-6523">Sunday:</span>
                  <span data-id="element-6524">Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-6525" />
    </div>;
};